import { SearchService } from './search-service';

let searchService = new SearchService();

export { searchService }